// @ts-expect-error untyped
import * as client from 'laboratory-lib/client';
import * as constants from 'laboratory-lib/constants';

/**
 * A noop function.
 */
const noop = () => {};

/**
 * A custom wrapper around fetch that returns a promise resolved with the JSON
 * of the response.
 *
 * @param method The HTTP method to use (GET or POST)
 * @param endpoint The endpoint to fetch
 * @param options The fetch options
 * @returns A promise resolved with the JSON of the response
 */
const fetchAsJson = (method, endpoint, {
  data
}) => fetch(endpoint, {
  method,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  },
  credentials: 'include',
  body: JSON.stringify(data)
}).then(response => response.json());

// Custom standalone implementations of some required interfaces and dependencies

const quickFetchImplementation = {
  getRequestStateByName: noop,
  makeEarlyRequest: noop,
  getApiUrl: noop
};

/**
 * This is a simple implementation of the http interface that uses fetch instead
 * of hub-http to trim down the size of the standalone library.
 */
const httpImplementation = {
  get: (endpoint, {
    data
  }) => fetchAsJson('GET', endpoint, {
    data
  }),
  post: (endpoint, {
    data
  }) => fetchAsJson('POST', endpoint, {
    data
  })
};

/**
 * This is here simply to satisfy the type checker.
 * For scenarios where we hydrate the client with treatments, another store
 * implementation will be provided by the server to replace this one.
 *
 * Important. Providing this implementation means that no cache will be
 * used on the client side for consumers of this standalone library.
 */
const storeImplementation = {
  get: () => Promise.resolve({}),
  set: () => Promise.resolve(),
  has: () => Promise.resolve(false),
  delete: () => Promise.resolve(),
  open: () => Promise.resolve(),
  close: () => Promise.resolve()
};

// @ts-expect-error no-declarations rule prevents me from declaring this properly
globalThis.createClient = function createClient({
  onError = err => {
    console.error(err);
  },
  store = storeImplementation,
  quickFetch = quickFetchImplementation,
  http = httpImplementation,
  timeout = constants.TIMEOUT_DEFAULT,
  // This should be null to prevent the client from fetching the treatments from quickFetch
  quickFetchLabel = null,
  treatments = null,
  identifiers = null,
  experiments = null,
  apiDomain = null,
  ceid = null,
  mode = null,
  name = null
} = {}) {
  return client.createClient({
    onError,
    store,
    timeout,
    http,
    quickFetchLabel,
    quickFetch,
    treatments,
    identifiers,
    experiments,
    apiDomain,
    ceid,
    mode,
    name
  });
};